import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ProtectedRoute from "./components/ProtectedRoute";
import CssBaseline from "@mui/material/CssBaseline";
import DashboardPage from "./pages/Dashboard";
import SettingsPage from "./pages/Settings";
import Calender from "./pages/Calender";
import AuthPage from "./pages/Auth";
import AdminPage from "./pages/Admin";
import SupportPage from "./pages/Support";
import EmailsPage from "./pages/Email";
import Asset_OverviewPage from "./pages/Asset_Overview";
import RentIncreasesPage from "./pages/Rent_Increases";
import TenantChangesPage from "./pages/Tenant_Changes";

// Create Material-UI theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
    background: {
      default: "#f8f9fa",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h6: {
      fontWeight: 400,
    },
  },
  shape: {
    borderRadius: 12,
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<AuthPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <ProtectedRoute>
                <Calender />
              </ProtectedRoute>
            }
          />
          <Route
            path="/emails"
            element={
              <ProtectedRoute>
                <EmailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/asset-overview"
            element={
              <ProtectedRoute>
                <Asset_OverviewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tenant-changes"
            element={
              <ProtectedRoute>
                <TenantChangesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rent-increases"
            element={
              <ProtectedRoute>
                <RentIncreasesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/support"
            element={
              <ProtectedRoute>
                <SupportPage />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
